import ReportStore from 'es/app/views/site/reports/ReportStore';
import { useLocalObservable } from 'mobx-react';
import React, { useContext } from 'react';
import AlertEventDetailsStore from './alerts/AlertEventDetailsStore';
import CalpuffConfigurationStore from './processes/edit/monitor/CalpufConfigurationsStore';

const createSiteStore = () => ({
    alertEventLogStore: new AlertEventDetailsStore(),
    calpuffConfigurationStore: new CalpuffConfigurationStore(),
    reportStore: new ReportStore(),
});

type SiteStore = ReturnType<typeof createSiteStore>;
const SiteStoresContext = React.createContext<SiteStore | null>(null);

export const SiteStoresProvider = (props: React.PropsWithChildren<unknown>) => {
    const store = useLocalObservable<SiteStore>(createSiteStore);
    return <SiteStoresContext.Provider value={store}>{props.children}</SiteStoresContext.Provider>;
};

const useSiteStore = () => {
    const ctx = useContext(SiteStoresContext);
    if (!ctx) throw new Error('No Site Store context. Is there a wrapping Provider?');
    return ctx;
};

export const useAlertEventLogStore = () => useSiteStore().alertEventLogStore;
export const useCalpuffConfigurationStore = () => useSiteStore().calpuffConfigurationStore;
export { useModelStore } from './models/useModelStore';
export { useProcessStore } from './useProcessStore';
export { useFileStore } from './files/FileStore';
